/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CourseUnit, OtmId } from 'common-typescript/types';
import { CourseUnitInfoVersion } from 'sis-components/courseUnitInfo/course-unit-info.service';
import { SelectOption } from 'sis-components/select/select-combobox/select-combobox.component';
import { sisuChain } from 'sis-components/util/utils';

@Component({
    selector: 'app-course-unit-info-modal-header-version-selector',
    templateUrl: './course-unit-info-modal-header-version-selector.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitInfoModalHeaderVersionSelectorComponent {
    @Input() courseUnit: CourseUnit;
    @Input() options: SelectOption[];
    @Input() courseUnitVersions: CourseUnitInfoVersion[];
    @Output() setModalCourseUnitVersion = new EventEmitter<CourseUnit>();

    onCourseUnitVersionChange(courseUnitId: OtmId): void {
        const courseUnit = sisuChain(this.courseUnitVersions).map('courseUnit').find({ id: courseUnitId }).value();
        this.setModalCourseUnitVersion.emit(courseUnit);
    }
}
